import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { IBrandReference, BrandReference } from './BrandReference';

export interface IServiceDomain extends IEntity {
  attributes: {
    id: EntityStringId;
    default: boolean;
    domain: string;
    service: string;
  };
  associations: {
    brand: IBrandReference;
  },
}

export type ServiceDomain = Entity<IServiceDomain>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServiceDomain: IEntityType<IServiceDomain> = vmClient.defineClass({
  typeName: 'ServiceDomain',
  version: 1,
  persisted: true,

  attributes: {
    default: {
      type: 'boolean',
      notNull: true,
    },
    domain: {
      type: 'string',
      notNull: true,
    },
    service: {
      type: 'string',
      notNull: true,
    },
  },

  associations: {
    brand: {
      type: BrandReference,
      notNull: true,
      shared: true,
    },
  },
});
